import * as React from "react";

import Select, { SelectProps } from "./Select";

export interface SliderHeadingProps {
	data?: RecommendationHeading;
	error?: boolean;
}
export interface RecommendationHeading {
	title: string;
	categories: SelectProps;
}

const SliderHeading = (props: SliderHeadingProps) => {
	return (
		<header>
			{props.data ? (
				<>
					{" "}
					<label
						data-test="cshp-recommendation-title"
						className="label"
						htmlFor={`cshp-recommendation-select-${props.data.categories.kind}`}
					>
						{props.data.title}
					</label>{" "}
					<Select {...props.data.categories} />{" "}
				</>
			) : null}
		</header>
	);
};

SliderHeading.displayName = "SliderHeading";
export default SliderHeading;
